import React from 'react';
import './analysis.css'

const Time = ({Time}) => {
    return (
        <div className='analysis'>
            Time: {Time}  milliseconds
        </div>
    );
}

export default Time;
